// PromoShowcase builder architecture foundation.
//
// The builder must remain output-neutral. Today, published output is synchronized
// to WordPress. In the future, Elite Core can render the same builder document
// directly without changing the editor's internal document model.

export const PROMOSHOWCASE_BUILDER_SCHEMA_VERSION = 1;

export const BUILDER_OUTPUT_TARGETS = Object.freeze({
  WORDPRESS: 'wordpress',
  NATIVE: 'native',
});

export const BUILDER_DEVICE_MODES = Object.freeze({
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  MOBILE: 'mobile',
});

export const createBuilderDocument = ({
  instanceUniqueId = '',
  templateKey = null,
  pages = {},
  globalStyles = {},
  metadata = {},
} = {}) => ({
  schemaVersion: PROMOSHOWCASE_BUILDER_SCHEMA_VERSION,
  instanceUniqueId,
  templateKey,
  pages,
  globalStyles,
  metadata: {
    ...metadata,
    updatedAt: new Date().toISOString(),
  },
});

export const normalizeBuilderDocument = (document = {}) => {
  const source = document && typeof document === 'object' ? document : {};

  return createBuilderDocument({
    instanceUniqueId: String(source.instanceUniqueId || ''),
    templateKey: source.templateKey || null,
    pages: source.pages && typeof source.pages === 'object' ? source.pages : {},
    globalStyles:
      source.globalStyles && typeof source.globalStyles === 'object'
        ? source.globalStyles
        : {},
    metadata: source.metadata && typeof source.metadata === 'object' ? source.metadata : {},
  });
};

export const createPublishEnvelope = ({
  document,
  target = BUILDER_OUTPUT_TARGETS.WORDPRESS,
  revisionId = null,
} = {}) => ({
  target,
  revisionId,
  document: normalizeBuilderDocument(document),
});

export const isKnownOutputTarget = (value) =>
  Object.values(BUILDER_OUTPUT_TARGETS).includes(value);
